import bus from '@/assets/js/bus';
import { getUserName,setUserName,clearUserName,getUserSign,setUserSign,clearUserSign } from '@/assets/js/user';

import { BigNumber as web3BigNumber } from "@ethersproject/bignumber";
import { BigNumber as BigNumberJs } from "bignumber.js";
import Web3 from 'web3';

const USDT_JSON = require("@/assets/abi/USDT.json");
const QaiTeam_JSON = require("@/assets/abi/QaiTeam.json");
const QaiHome_JSON = require("@/assets/abi/QaiHome.json");
const QaiToken_JSON = require("@/assets/abi/QaiToken.json");


const MpcToken_JSON = require("@/assets/abi/mpc/MpcToken.json");
const MpcTeam_JSON = require("@/assets/abi/mpc/MpcTeam.json");
const MpcHome_JSON = require("@/assets/abi/mpc/MpcHome.json");
const MpcExchange_JSON = require("@/assets/abi/mpc/MpcExchange.json");

let BASE_SCAN_URLS = {
    56: 'https://bscscan.com',
    97: 'https://testnet.bscscan.com'
};
let BASE_NODES = {
    56: ['https://bsc-dataseed1.ninicoin.io', 'https://bsc-dataseed1.defibit.io', 'https://bsc-dataseed.binance.org'],
    // 97: ['https://data-seed-prebsc-1-s1.binance.org:8545', 'https://data-seed-prebsc-2-s1.binance.org:8545', 'https://data-seed-prebsc-1-s2.binance.org:8545']
    97: ["https://bsc-testnet.nodereal.io/v1/e9a36765eb8a40b9bd12e680a1fd2bc5"]
};

export default {
    install(Vue) {
        Vue.prototype.chainId = 56;

        Vue.prototype.isMainnet = function() {
            return Vue.prototype.chainId == 56;
        }

        Vue.prototype.getChainScan = function(){
            return BASE_SCAN_URLS[Vue.prototype.chainId];
        }

        if(Vue.prototype.chainId == 56){
            // Vue.prototype.zeroAddress = "0x0000000000000000000000000000000000000000";
            // Vue.prototype.dappAdminAddress = "0x85Ccad5bfC1F1DB13573B9C38edE6F3ba580D128";//矿池管理员

            // // const TokenUsdt_ADDRESS = "0x55d398326f99059fF775485246999027B3197955";// USDT
            // const TokenUsdt_ADDRESS = "0x4fffBb0bbECfDca7D23f8dCceEF21154bE516EDA";// TUSDT
            // const TokenMpc_ADDRESS = "0x86686f5a92550Bcf75bFf5a7C657528C41eC5261";// MPC
            // const TokenStc_ADDRESS = "0xA3b906687F757B71CF43441e22Aa2d578DE5aD2B";// STC
            // const TokenXl_ADDRESS = "0xbB883aF0A1E83d8243E6879a5e048809816c43bB";// XL

            // const MpcTeam_ADDRESS = "0xB03c14327EC8ce6Ae6cA31cB3195bBCb946be61d";// MpcTeam
            // const MpcExchange_ADDRESS = "0x99eCa5f6b9320bfD9bA363C9fFF1c8cB0cc934F8";// MpcExchange
            // const MpcHome_ADDRESS = "0x188DD7960736370db00EfFB02901C50277f3382D";// MpcHome

            
            // Vue.prototype.TokenUsdt_Contract = {abi:USDT_JSON,address:TokenUsdt_ADDRESS};
            // Vue.prototype.TokenMpc_Contract = {abi:MpcToken_JSON,address:TokenMpc_ADDRESS};
            // Vue.prototype.TokenStc_Contract = {abi:MpcToken_JSON,address:TokenStc_ADDRESS};
            // Vue.prototype.TokenXl_Contract = {abi:MpcToken_JSON,address:TokenXl_ADDRESS};

            // Vue.prototype.MpcTeam_Contract = {abi:MpcTeam_JSON,address:MpcTeam_ADDRESS};
            // Vue.prototype.MpcExchange_Contract = {abi:MpcExchange_JSON,address:MpcExchange_ADDRESS};
            // Vue.prototype.MpcHome_Contract = {abi:MpcHome_JSON,address:MpcHome_ADDRESS};

            Vue.prototype.zeroAddress = "0x0000000000000000000000000000000000000000";
            Vue.prototype.dappAdminAddress = "0xfdf4db90482758c86b3806ab4879e9c85a3ac446";

            const TokenUsdt_ADDRESS = "0x55d398326f99059fF775485246999027B3197955";// USDT

            const TokenMpc_ADDRESS = "0x7a5ecAf901732005dc487Aef72BB08D1852b9bA3";// MPC
            const TokenStc_ADDRESS = "0x6ce3dAc5D9087b5636093A74fa37af7616105276";// STC
            const TokenXl_ADDRESS = "0xCDe102aeA2c97e849Dba724D63c30441FB0621a7";// XL
            const TokenMine_ADDRESS = "0x8b36d1AB78497ba360D0291C3971Ef73A5D5d366";// MINE

            // const MpcTeam_ADDRESS = "0xD0Cd6dB34A84340aC24883568AB889e9A8215E29";// MpcTeam
            // const MpcExchange_ADDRESS = "0x3dB2E39a55147d6CA344868137abf5806ec2059F";// MpcExchange
            // const MpcExchange_ADDRESS = "0x108a17F8350f4D57CE60E392cc298c1f6a68B659";// MpcExchange2
            // const MpcHome_ADDRESS = "0x7e7ED5f55Bc2984b9E02b2305Ee2D8859a3A10AD";// MpcHome
            // const MpcHome_ADDRESS = "0x2D3A2151B826F151f60913Fe5b9D6b7717C64678";// MpcHome2
            
            const MpcTeam_ADDRESS = "0x0989b9a504501296E60237c6B2D3107ef0a28D8d";// MpcTeam3
            const MpcHome_ADDRESS = "0xE650e417c8bba5577873172CDDdc58D474ECDFef";// MpcHome3
            const MpcExchange_ADDRESS = "0x827B0e8D585Be0b7a4bc47be144806D79D1C567a";// MpcExchange3

            Vue.prototype.TokenUsdt_Contract = {abi:USDT_JSON,address:TokenUsdt_ADDRESS};
            Vue.prototype.TokenMpc_Contract = {abi:MpcToken_JSON,address:TokenMpc_ADDRESS};
            Vue.prototype.TokenStc_Contract = {abi:MpcToken_JSON,address:TokenStc_ADDRESS};
            Vue.prototype.TokenXl_Contract = {abi:MpcToken_JSON,address:TokenXl_ADDRESS};
            Vue.prototype.TokenMine_Contract = {abi:MpcToken_JSON,address:TokenMine_ADDRESS};

            Vue.prototype.MpcTeam_Contract = {abi:MpcTeam_JSON,address:MpcTeam_ADDRESS};
            Vue.prototype.MpcExchange_Contract = {abi:MpcExchange_JSON,address:MpcExchange_ADDRESS};
            Vue.prototype.MpcHome_Contract = {abi:MpcHome_JSON,address:MpcHome_ADDRESS};

        }else if(Vue.prototype.chainId == 97){
            // Vue.prototype.zeroAddress = "0x0000000000000000000000000000000000000000";
            // Vue.prototype.dappAdminAddress = "0x24f8ed236B6DE8E783BA5803274a8c7d8457A980";//矿池管理员

            // const TokenMpc_ADDRESS = "0xa0698245311C5A31E40d7699935b54Ef99093363";// MPC
            // const TokenStc_ADDRESS = "0xAC82F015a22c8D42d88BCCeCf3D8E157ABcEFfD5";// STC
            // const TokenXl_ADDRESS = "0xB0B11d227d711DFfe5a33eF18bd240D31fCB69E0";// XL
            // const TokenUsdt_ADDRESS = "0x5436d8ECC9659b73a3C34EbbCAa6dB353EfDd334";// USDT
            // const TokenMine_ADDRESS = "0xB0B11d227d711DFfe5a33eF18bd240D31fCB69E0";// XL test

            // const MpcTeam_ADDRESS = "0x2f9Cb36cFb1442C3F1e2238d7DFC781b390B352E";// MpcTeam
            // // const MpcExchange_ADDRESS = "0xDbfe85f8761395Fd68278d2251D06Ee1E3EC38c4";// MpcExchange
            // const MpcExchange_ADDRESS = "0x355d0fDD7a504D6F00480B4CeaAE70c24BC2CA6B";// MpcExchange3
            // const MpcHome_ADDRESS = "0x017ecc275D1ce4f7cf3D8ca8e5e387bFEEC19fC6";// MpcHome
            // // const MpcHome_ADDRESS = "0x1e76DAdB0c860167aBc99E5ff6db8152133427E3";// MpcHome2

            // Vue.prototype.MpcTeam_Contract = {abi:MpcTeam_JSON,address:MpcTeam_ADDRESS};
            // Vue.prototype.MpcHome_Contract = {abi:MpcHome_JSON,address:MpcHome_ADDRESS};
            // Vue.prototype.MpcExchange_Contract = {abi:MpcExchange_JSON,address:MpcExchange_ADDRESS};

            // Vue.prototype.TokenMpc_Contract = {abi:MpcToken_JSON,address:TokenMpc_ADDRESS};
            // Vue.prototype.TokenStc_Contract = {abi:MpcToken_JSON,address:TokenStc_ADDRESS};
            // Vue.prototype.TokenXl_Contract = {abi:MpcToken_JSON,address:TokenXl_ADDRESS};
            // Vue.prototype.TokenUsdt_Contract = {abi:USDT_JSON,address:TokenUsdt_ADDRESS};
            // Vue.prototype.TokenMine_Contract = {abi:MpcToken_JSON,address:TokenMine_ADDRESS};
        }
        Vue.prototype.showAddress = function(address) {
            if(!address){
                return "";
            }
            if (address.length <= 10) {
                return address;
            }
            return address.slice(0, 6) + "..." + address.slice(-4);
        }
        Vue.prototype.convertToBigIntByUnit = function(value,unit){
            let temp =  new BigNumberJs(value).multipliedBy(new BigNumberJs(Math.pow(10, unit))).dp(0,BigNumberJs.ROUND_HALF_DOWN).toFixed();
            return BigInt(temp);
        }
        Vue.prototype.convertToBigNumberByUnit = function(value,unit){
            if (!value) {
                return web3BigNumber.from(0);
            }
            let temp = new BigNumberJs(value).multipliedBy(new BigNumberJs(Math.pow(10, unit))).dp(0,BigNumberJs.ROUND_HALF_DOWN).toFixed();
            let result = web3BigNumber.from(temp);
            return result;
        }
        Vue.prototype.convertToBigNumber = function(value){
            if (!value) {
                return web3BigNumber.from(0);
            }
            let temp = new BigNumberJs(value).toString(10);
            let result = web3BigNumber.from(temp);
            return result;
        }
        Vue.prototype.bigIntToBigNumber = function(value){
            let result = web3BigNumber.from(value.toString());
            return result;
        }
        Vue.prototype.convertFromByUnit = function(value,unit) {
            return new BigNumberJs(value).div(new BigNumberJs(Math.pow(10, unit))).toNumber();
        }
        //默认保留2位，向上取整
        Vue.prototype.convertUp = function(value,unit,xs=2) {
            return new BigNumberJs(value).div(new BigNumberJs(Math.pow(10, unit))).decimalPlaces(xs,BigNumberJs.ROUND_UP).toNumber();
        }
        Vue.prototype.convertDown = function(value,xs=2) {
            console.log("value:",value);
            return new BigNumberJs(value).decimalPlaces(xs,BigNumberJs.ROUND_DOWN).toNumber();
        }
        Vue.prototype.showDataAuto = function(value) {
            let xs;
            if(value == 0){
                return 0;
            }else if(value <= 0.00000000000001){
                xs = 18;
            }else if(value <= 0.0000000000001){
                xs = 17;
            }else if(value <= 0.00000000001){
                xs = 16;
            }else if(value <= 0.0000000001){
                xs = 15;
            }else if(value <= 0.000000001){
                xs = 14;
            }else if(value <= 0.00000001){
                xs = 13;
            }else if(value <= 0.0000001){
                xs = 12;
            }else if(value <= 0.000001){
                xs = 11;
            }else if(value <= 0.00001){
                xs = 10;
            }else if(value <= 0.0001){
                xs = 8;
            }else if(value <= 0.01){
                xs = 6;
            }else if(value <= 1){
                xs = 5;
            }else if(value <= 100){
                xs = 4;
            }else if(value <= 10000){
                xs = 3;
            }else if(value <= 100000){
                xs = 2;
            }else if(value <= 1000000){
                xs = 1;
            }else{
                xs = 0;
            }
            return new BigNumberJs(value).dp(xs, BigNumberJs.ROUND_DOWN).toString(10);
        }
        Vue.prototype.web3Instance = null;
        Vue.prototype.tokenApprove = async (tokenInstance,owner, spender,amount)=> {
            try{
                let params;
                if(Vue.prototype.isMainnet() && Vue.prototype.web3Instance){
                    let gasPrice = await Vue.prototype.web3Instance.eth.getGasPrice();
                    params = {from: owner,gasPrice:gasPrice};
                }else{
                    params = {from: owner};
                }
                let result = await tokenInstance.methods.approve(spender,amount).send(params);
                if(result.status){
                    return true;
                }else{
                    return false;
                }
            }catch (error) {
                console.log(error);
                return false;
            }
        }
        Vue.prototype.contractSend = async (method, from, value) => {
            let params;
            if(Vue.prototype.isMainnet() && Vue.prototype.web3Instance){
                let gasPrice = await Vue.prototype.web3Instance.eth.getGasPrice();
                params = {from: from ? from : getUserName(), value: value ? value : 0,gasPrice:gasPrice};
            }else{
                params = {from: from ? from : getUserName(), value: value ? value : 0};
            }
            return method.send(params);
        }
        // Vue.prototype.contractSend = async (method, from, value) => {
        //     let params;
        //     // if(Vue.prototype.isMainnet() && Vue.prototype.web3Instance){
        //     //     let gasPrice = await Vue.prototype.web3Instance.eth.getGasPrice();
        //     //     console.log("gasPrice:",gasprice);
        //     //     // PSC链：300000000
        //     //     // BSC链：100000000
        //     //     params = {from: from, value: value ? value : 0,gasPrice: gasPrice};
        //     // }else{
        //     //     params = {from: from, value: value ? value : 0};
        //     // }
        //     params = {from: from, value: value ? value : 0,gasPrice: 300000000};
        //     return method.send(params);
        // }
        Vue.prototype.connectWallet = async function (callback){
            let _this = this;
            if (Vue.prototype.isMobile()) {
                console.log("Automatically reconnect")
                _this.excuteConnect((failInfo) => {
                    console.log(failInfo);
                    setTimeout(function () {
                        _this.connectWallet(callback);
                    }, 1000);
                }, callback);
            } else {
                console.log("Only connect once")
                _this.excuteConnect((failInfo) => {
                    console.log(failInfo);
                }, callback);
            }
        }

        Vue.prototype.excuteConnect = async function (connectFail, callback){
            let chainIdHex = "0x" + Vue.prototype.chainId.toString(16);
            if (!window.ethereum) {
                connectFail("window.ethereum is null");
                return false;
            }
            let changeChain = true;
            if (changeChain) {
                if (window.ethereum.chainId != chainIdHex) {
                    await window.ethereum.request({
                        method: 'wallet_switchEthereumChain',
                        params: [{chainId: chainIdHex}]
                    }).then(async (res) => {
                        // switch success ，"chainChanged"
                        this.getWalletAddress(connectFail, callback);
                    }).catch(async (switchError) => {
                        console.log("switch error:", switchError);
                        await window.ethereum.request({
                            method: 'wallet_addEthereumChain',
                            params: [{
                                chainId: chainIdHex,
                                chainName: Vue.prototype.chainId === 56 ? 'Binance Smart Chain Mainnet' : 'Binance Smart Chain Testnet',
                                nativeCurrency: {
                                    name: 'BNB',
                                    symbol: 'BNB',
                                    decimals: 18
                                },
                                rpcUrls: BASE_NODES[Vue.prototype.chainId],
                                blockExplorerUrls: [BASE_SCAN_URLS[Vue.prototype.chainId]]
                            }]
                        }).then(async (res) => {
                            // add success ，"chainChanged"
                        }).catch((addError) => {
                            console.log("add error:", addError);
                            connectFail(addError);
                        });
                    });
                } else {
                    this.getWalletAddress(connectFail, callback);
                }
            } else {
                if (window.ethereum.chainId != chainIdHex) {
                    connectFail("chainId error")
                    return;
                }
                this.getWalletAddress(connectFail, callback);
            }
        }

        Vue.prototype.getWalletAddress = async function (connectFail, callback){
            const web3Instance = new Web3(window.ethereum);
            Vue.prototype.web3Instance = web3Instance;
            await window.ethereum.request({method: "eth_requestAccounts"}).then(async (res) => {
                // let walletAddress = window.ethereum.selectedAddress;
                let walletAddress = res[0];
                console.log("walletAddress:",walletAddress)
                Vue.prototype.walletAddress = walletAddress;

                setUserName(walletAddress);
                Vue.prototype.hideConnectWalletBox();
                bus.$emit('hideConnectWalletBox');
                bus.$emit('showWalletAddress');
                bus.$emit('refreshWalletData');
                if(callback){
                    callback(walletAddress);
                }else{
                    // this.goHome();
                }
            }).catch((err) => {
                connectFail(err);
                return;
            });
        }
    }
}

  